/**
 * TanStack Query hooks for `schedule-based-triggers-day-parting-timezone-aware`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	scheduleBasedTriggersDayPartingTimezoneAwareQueryKeys,
	type CreateScheduleBasedTriggersDayPartingTimezoneAwareBody,
	type ListScheduleBasedTriggersDayPartingTimezoneAwareResponse,
	type ScheduleBasedTriggersDayPartingTimezoneAwareRow,
} from "./api";

export function useScheduleBasedTriggersDayPartingTimezoneAwareList(): UseQueryResult<ListScheduleBasedTriggersDayPartingTimezoneAwareResponse, Error> {
	return useQuery({
		queryKey: scheduleBasedTriggersDayPartingTimezoneAwareQueryKeys.list(),
		queryFn: list,
	});
}

export function useScheduleBasedTriggersDayPartingTimezoneAwareCreate(): UseMutationResult<ScheduleBasedTriggersDayPartingTimezoneAwareRow, Error, CreateScheduleBasedTriggersDayPartingTimezoneAwareBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scheduleBasedTriggersDayPartingTimezoneAwareQueryKeys.all });
		},
	});
}

export function useScheduleBasedTriggersDayPartingTimezoneAwareDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scheduleBasedTriggersDayPartingTimezoneAwareQueryKeys.all });
		},
	});
}
